import React, { FunctionComponent, useEffect } from 'react';

import { Locale } from '@components/common/language_menu/languagesMap';
import LanguageMenuDropdown from '@components/common/language_menu/LanguageMenuDropdown';
import { determineUGTLocale } from '@components/asset/modal/tabs/edit/helpers';

import './styles/_bulk_management_language_menu_dropdown.scss';

const reloadWithSelectedLocale = (selectedLocale: Locale, prevLocale: Locale | ''): boolean => {
  if (selectedLocale === prevLocale) {
    return false;
  }

  const newLocale = selectedLocale;
  const currentHrefPieces = window.location.href.split('#');
  const separator = currentHrefPieces[0].includes("?") ? "&" : "?";
  let newUrl = `${currentHrefPieces[0]}${separator}ugt_locale=${newLocale}#${currentHrefPieces[1]}`;

  if (prevLocale && currentHrefPieces[0].includes("ugt_locale=")) {
    newUrl = window.location.href.replace(`ugt_locale=${prevLocale}`, `ugt_locale=${newLocale}`);
  }

  window.location.href = newUrl;
  return true;
};

export const getCurrUrlLocale = (): Locale | '' => {
  const currentHref = window.location.href.split('#')[0];
  const ugtParamString = "ugt_locale=";
  const localeIndex = currentHref.indexOf(ugtParamString);
  if (localeIndex > -1) {
    return currentHref.substr(localeIndex + ugtParamString.length, 2) as Locale;
  }

  return '';
};

const BulkManagementLanguageMenuDropdown: FunctionComponent<{}> = () => {
  const { ugtLocaleDefault } = BFG.locales;

  if (!BFG.hasFeature("translations")) {
    return null;
  }

  const storedUgtLocale = determineUGTLocale();

  return (
    <LanguageMenuDropdown
      copy={t('Select from the list below in order to edit fields for that language.')}
      defaultLocale={ugtLocaleDefault}
      onLocaleChange={(selectedLocale: Locale): boolean => reloadWithSelectedLocale(selectedLocale, getCurrUrlLocale())}
      openOnHover={false}
      selectedLocale={getCurrUrlLocale() || storedUgtLocale || ugtLocaleDefault}
      showSelectedLocaleName
      wrapperClassnames="bulk-management-ugt"
    />
  );
};

export default BulkManagementLanguageMenuDropdown;
